import Footer from '../home/components/Footer';
import PageSEO from '../../components/feature/PageSEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://arvakon.com';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-white">
      <PageSEO
        title="Terms of Service – Arvakon | Independent Technical Verification"
        description="Arvakon terms of service. Understand the conditions governing use of our website and technical verification services."
        keywords="Arvakon terms of service, service conditions, technical verification terms"
        canonical={`${siteUrl}/terms-of-service`}
      />

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
          <a href="/" className="text-dark-primary text-xl font-semibold tracking-tight">
            ARVAKON
          </a>
          <nav className="flex items-center gap-8">
            <a href="/" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Home</a>
            <a href="/services" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Services</a>
            <a href="/standards" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Standards</a>
            <a href="/projects" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Industry Applications</a>
            <a href="/about" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">About</a>
            <a href="/contact" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Contact</a>
          </nav>
        </div>
      </header>

      {/* Page Header */}
      <div className="pt-40 pb-20 px-8 bg-[#F8FAFC] border-b border-slate-200">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
            Legal
          </p>
          <h1 className="font-serif text-4xl text-dark-primary tracking-tight">
            Terms of Service
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <main className="py-24 px-8">
        <div className="max-w-4xl mx-auto space-y-8">

          <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
            <p>
              Arvakon provides independent technical verification, manufacturing surveillance, witnessing, and structured technical reporting services within the defined scope agreed with the client.
            </p>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Scope and Limitations:
            </h2>
            <ul className="space-y-2 text-slate-600 text-[15px] leading-[1.85]">
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>Arvakon does not act as a notified body and does not issue regulatory approvals.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>Arvakon does not provide certification authority functions or final equipment acceptance authority.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>Final regulatory approval, certification authority decisions, and equipment acceptance remain with the designated client, purchaser, or regulatory body.</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Use of Website:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Information on this website is for general reference. Submission of a Technical Inquiry does not create a contractual relationship. Any service engagement is subject to formal scope definition and contractual agreement.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Liability:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Arvakon is not responsible for decisions made by third parties based on publicly available website information.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Governing Framework:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Where applicable, services are performed against client-defined specifications and applicable international codes and standards within the agreed project scope.
              </p>
            </div>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}